import { isShapeValidToken } from "@/shared/utils/token";
import EmailPreferencesView from "@/modules/consent/presentation/views/EmailPreferencesView.vue";
import EmailPreferencesResultView from "@/modules/consent/presentation/views/EmailPreferencesResultView.vue";
/**
 * Per-route guard for the token-gated surfaces. A token-shaped-but-invalid value (wrong length /
 * illegal chars) must never reach the form — it falls through to the generic ErrorView WITHOUT
 * leaking whether a contact exists. Crypto validation stays server-side in OPINK; this is
 * shape-only.
 */
export function requireShapeValidToken(to) {
    const raw = to.params.token;
    const token = Array.isArray(raw) ? raw[0] : raw;
    return isShapeValidToken(token) ? true : { name: "Error" };
}
export const consentRoutes = [
    {
        // CONSTRAINT: this route outlives the in-body unsubscribe link OP-7732 removed. Two sources
        // still reach it on a browser GET — the RFC 8058 List-Unsubscribe URL, and any email delivered
        // before OP-7732 whose frozen body still carries `{{var:unsubscribe_url}}`. Neither is greppable
        // from the editor side, so "nothing links here any more" is the wrong conclusion to draw.
        // Per US-2.2 the GET renders the purpose-level unsubscribe form (US-5.19) — the SAME form the
        // preference center (`{{preference_center_url}}`) renders. The one-click stays a separate POST
        // rewritten by nginx to OPINK.
        path: "/communications/unsubscribe/:token",
        name: "Unsubscribe",
        component: EmailPreferencesView,
        props: true,
        beforeEnter: requireShapeValidToken,
        meta: { titleKey: "emailPreferences.title" },
    },
    {
        path: "/communications/email-preferences/:token",
        name: "EmailPreferences",
        component: EmailPreferencesView,
        props: true,
        beforeEnter: requireShapeValidToken,
        meta: { titleKey: "emailPreferences.title" },
    },
    {
        path: "/communications/email-preferences/:token/updated",
        name: "EmailPreferencesUpdated",
        component: EmailPreferencesResultView,
        props: (route) => ({ token: route.params.token, variant: "updated" }),
        beforeEnter: requireShapeValidToken,
        meta: { titleKey: "emailPreferences.result.updated.title" },
    },
    {
        path: "/communications/email-preferences/:token/unsubscribed",
        name: "EmailPreferencesUnsubscribedAll",
        component: EmailPreferencesResultView,
        props: (route) => ({ token: route.params.token, variant: "unsubscribedAll" }),
        beforeEnter: requireShapeValidToken,
        meta: { titleKey: "emailPreferences.result.unsubscribedAll.title" },
    },
];
export const consentNavigationItems = [];
